// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TeamCard.scss */
.golf-league-team-card {
  padding: 24px;
}

.golf-league-team-card-container {
  width: 100%;
  max-width: 350px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.golf-league-team-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.golf-league-team-info {
  display: flex;
  flex-direction: column;
}

.golf-league-team-name {
  font-weight: bold !important;
  font-size: 18px;
  text-align: left;
  margin: 0 0 4px 0;
}

.golf-league-team-rank {
  font-size: 16px;
  margin: 0;
  text-align: left;
}

.golf-league-team-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.golf-league-team-logo img {
  width: 70px;
  height: 70px;
}

/* Events section */
.golf-league-events-container {
  margin-top: 16px;
  position: relative;
}

.golf-league-events-container::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 30px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255));
  pointer-events: none;
  z-index: 1;
}

.golf-league-events-scroll {
  display: flex;
  overflow-x: auto;
  padding: 5px 0;
  padding-bottom: 8px;
  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
  scrollbar-width: thin; /* Firefox */
  scroll-behavior: smooth; /* Enable smooth scrolling */
  /* Center items when they don't overflow */
  justify-content: center;
  /* Ensure last item has space */
  padding-right: 20px;
  /* Add a min-width to ensure centering works properly */
  min-width: 100%;
}

/* When content overflows, align items to the left */
.golf-league-events-scroll.overflow {
  justify-content: flex-start;
}

/* Customize scrollbar appearance */
.golf-league-events-scroll::-webkit-scrollbar {
  height: 6px;
}

.golf-league-events-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.golf-league-events-scroll::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 10px;
}

.golf-league-events-scroll::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}

.golf-league-event-item {
  min-width: 100px;
  text-align: center;
  margin-right: 20px;
  flex-shrink: 0;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.golf-league-event-item:last-child {
  margin-right: 0;
}

.golf-league-event-title {
  font-weight: bold !important;
  margin-bottom: 4px;
  text-align: center;
  text-decoration: underline;
}

.golf-league-event-value {
  color: #666;
  text-align: center;
  margin-bottom: 0;
  font-size: 14px;
}

.golf-league-card-footer {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.golf-league-roster-button {
  text-transform: none;
  border-radius: 6px;
  background-color: white;
  color: black;
  border: 1px solid #ccc;
  padding: 8px 12px !important;
  font-size: 12px !important;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.golf-league-roster-button:hover {
  background-color: #f5f5f5;
}

.golf-league-button-icon {
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/GolfLeague/TeamsPage/TeamCard.scss"],"names":[],"mappings":"AAAA,kBAAA;AACA;EACI,aAAA;AACJ;;AAEE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,wCAAA;AACJ;;AAEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;AACJ;;AAEE;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;AACJ;;AAEE,mBAAA;AACA;EACE,gBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,iFAAA;EACA,oBAAA;EACA,UAAA;AACJ;;AAEE;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA,EAAA,mCAAA;EACA,qBAAA,EAAA,YAAA;EACA,uBAAA,EAAA,4BAAA;EAEA,0CAAA;EACA,uBAAA;EAEA,+BAAA;EACA,mBAAA;EAEA,uDAAA;EACA,eAAA;AAFJ;;AAKE,oDAAA;AACA;EACE,2BAAA;AAFJ;;AAKE,mCAAA;AACA;EACE,WAAA;AAFJ;;AAKE;EACE,mBAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,gBAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,gBAAA;AAFJ;;AAKE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAFJ;;AAKE;EACE,eAAA;AAFJ;;AAKE;EACE,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AAFJ;;AAKE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAFJ;;AAKE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,yBAAA;AAFJ;;AAKE;EACE,gBAAA;AAFJ","sourcesContent":["/* TeamCard.scss */\n.golf-league-team-card {\n    padding: 24px;\n  }\n  \n  .golf-league-team-card-container {\n    width: 100%;\n    max-width: 350px;\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 0 auto;\n    border: 1px solid #e0e0e0;\n    padding: 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .golf-league-team-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 16px;\n  }\n  \n  .golf-league-team-info {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .golf-league-team-name {\n    font-weight: bold !important;\n    font-size: 18px;\n    text-align: left;\n    margin: 0 0 4px 0;\n  }\n  \n  .golf-league-team-rank {\n    font-size: 16px;\n    margin: 0;\n    text-align: left;\n  }\n  \n  .golf-league-team-logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .golf-league-team-logo img {\n    width: 70px;\n    height: 70px;\n  }\n  \n  /* Events section */\n  .golf-league-events-container {\n    margin-top: 16px;\n    position: relative;\n  }\n  \n  .golf-league-events-container::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 30px;\n    background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1));\n    pointer-events: none;\n    z-index: 1;\n  }\n  \n  .golf-league-events-scroll {\n    display: flex;\n    overflow-x: auto;\n    padding: 5px 0;\n    padding-bottom: 8px;\n    -ms-overflow-style: none;  /* Hide scrollbar for IE and Edge */\n    scrollbar-width: thin;     /* Firefox */\n    scroll-behavior: smooth;   /* Enable smooth scrolling */\n    \n    /* Center items when they don't overflow */\n    justify-content: center;\n    \n    /* Ensure last item has space */\n    padding-right: 20px;\n    \n    /* Add a min-width to ensure centering works properly */\n    min-width: 100%;\n  }\n  \n  /* When content overflows, align items to the left */\n  .golf-league-events-scroll.overflow {\n    justify-content: flex-start;\n  }\n  \n  /* Customize scrollbar appearance */\n  .golf-league-events-scroll::-webkit-scrollbar {\n    height: 6px;\n  }\n  \n  .golf-league-events-scroll::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n  }\n  \n  .golf-league-events-scroll::-webkit-scrollbar-thumb {\n    background: #ddd;\n    border-radius: 10px;\n  }\n  \n  .golf-league-events-scroll::-webkit-scrollbar-thumb:hover {\n    background: #ccc;\n  }\n  \n  .golf-league-event-item {\n    min-width: 100px;\n    text-align: center;\n    margin-right: 20px;\n    flex-shrink: 0;\n    padding: 4px;\n    border-radius: 4px;\n    transition: all 0.3s ease;\n  }\n  \n  .golf-league-event-item:last-child {\n    margin-right: 0;\n  }\n  \n  .golf-league-event-title {\n    font-weight: bold !important;\n    margin-bottom: 4px;\n    text-align: center;\n    text-decoration: underline;\n  }\n  \n  .golf-league-event-value {\n    color: #666;\n    text-align: center;\n    margin-bottom: 0;\n    font-size: 14px;\n  }\n  \n  .golf-league-card-footer {\n    display: flex;\n    justify-content: center;\n    margin-top: 16px;\n  }\n  \n  .golf-league-roster-button {\n    text-transform: none;\n    border-radius: 6px;\n    background-color: white;\n    color: black;\n    border: 1px solid #ccc;\n    padding: 8px 12px !important;\n    font-size: 12px !important;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n  }\n  \n  .golf-league-roster-button:hover {\n    background-color: #f5f5f5;\n  }\n  \n  .golf-league-button-icon {\n    margin-left: 6px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
